module.exports = __webpack_public_path__ + "assets/video_tutorial.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video_tutorial.mp4
// module id = 250
// module chunks = 1